import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone } from 'lucide-react';
import { trackInitiateCheckout } from '../lib/pixel';
export function Navbar() {
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className="fixed top-0 left-0 right-0 z-50 bg-zinc-950/80 backdrop-blur-md border-b border-zinc-800" data-id="element-178">
      <div className="max-w-6xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-179">
        <div className="flex items-center gap-2" data-id="element-180">
          <Smartphone className="w-5 h-5 text-blue-500" data-id="element-181" />
          <span className="text-white font-bold tracking-tight" data-id="element-182">
            Sistema iPhone Ads
          </span>
        </div>
        <a href="https://sistema-iphone-ads.myshopify.com/products/sistema-iphone-ads" onClick={trackInitiateCheckout} className="hidden md:inline-flex items-center justify-center px-5 py-2 text-sm font-semibold text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-colors" data-id="element-183">
          Comprar guía
        </a>
      </div>
    </motion.header>;
}